import { INSERT_MASTER_SHEET ,EQUIPMENT_LIST, 
  GET_INSPECTION_DROPDOWN, GET_INSPECTION,
   GET_WEAR_SUMMARY, GET_DASHBOARD, FORGOT_PASSWORD, RESET_PASSWORD, UPLOAD_PDF_URL,
    DOWNLOAD_PDF_URL, DELETE_INSPECTION, GET_USERS_ADMIN,
    UPDATE_USER_STATUS,
    CREATE_USER,
    UPDATE_USER_ACCESS,
    UPDATE_PROFILE} from "../config";
import apiClient from "./apiClient";


export async function insertMastersheet(json) {
  const response = await apiClient.post(INSERT_MASTER_SHEET,json);
  return response.data; // expects { token: '...' }
}

export async function getEquipments() {
  const response = await apiClient.get(EQUIPMENT_LIST);
  return response.data; // expects { token: '...' }
}

export async function getInspection() {
  const response = await apiClient.get(GET_INSPECTION_DROPDOWN);
  return response.data; // expects { token: '...' }
}


export async function getInspectionByPagination({page=1,limit=10}) {
  const response = await apiClient.get(`${GET_INSPECTION}?page=${page}&limit=${limit}`);
  return response.data; // expects { token: '...' }
}
export async function getUsersListByPagination({page=1,limit=10}) {
  const response = await apiClient.get(`${GET_USERS_ADMIN}?page=${page}&limit=${limit}`);
  return response.data; // expects { token: '...' }
}

export async function getWearSumary(json) {
  const response = await apiClient.post(GET_WEAR_SUMMARY,json);
  return response.data; // expects { token: '...' }
}
export async function getDashboard(json={}) {
  const response = await apiClient.get(GET_DASHBOARD);
  return response.data; // expects { token: '...' }
}
export async function sendPasswordEmail(json={}) {
  const response = await apiClient.post(FORGOT_PASSWORD,json);
  return response.data; // expects { token: '...' }
}


export async function resetPassword(json={}) {
  const response = await apiClient.post(RESET_PASSWORD,json);
  return response.data; // expects { token: '...' }
}
export async function uploadPdfApi(formData) {
  const response = await apiClient.post(UPLOAD_PDF_URL,formData);
  return response.data; // expects { token: '...' }
}

export async function downloadZipFile(fileName) {
  const response = await apiClient.get(`${DOWNLOAD_PDF_URL}${fileName}`);
  return response.data; // expects { token: '...' }
}

export async function deleteInspection(enc_id) {
  const response = await apiClient.delete(`${DELETE_INSPECTION}${enc_id}`);
  return response.data; // expects { token: '...' }
}

export async function updateUserStatus(enc_id,status) {
  const response = await apiClient.delete(`${UPDATE_USER_STATUS}${enc_id}/${status}`);
  return response.data; // expects { token: '...' }
}
export async function createUser(json) {
  const response = await apiClient.post(`${CREATE_USER}`,json);
  return response.data; // expects { token: '...' }
}

export async function updateUserAccess(enc_id, json) {
  const response = await apiClient.post(`${UPDATE_USER_ACCESS}${enc_id}`, json);
  return response.data;
}

export async function updateUserProfile(json) {
  const response = await apiClient.post(UPDATE_PROFILE, json);
  return response.data;
}

export async function getAllInsepction(enc_id) {
  const response = await apiClient.get(`${GET_INSPECTION}/${enc_id}`);
  return response.data; // expects { token: '...' }
}
